import { mouseAndWheelHorizontalScrollEvents } from '../js/helpers/mouseAndWheelHorizontalScrollEvents';
const observer = new ResizeObserver(entries => {
    for (const entry of entries) {
        if (entry.contentRect.width > 0) {
            entry.target.init();
            observer.unobserve(entry.target);
        }
    }
});
class ComponentSlider extends HTMLElement {
    slider;
    btnNext = null;
    btnPrev = null;
    connectedCallback() {
        const slider = this.querySelector('[data-slider]');
        if (slider === null ||
            (this.dataset.sliderInitFrom !== undefined &&
                !window.matchMedia(`(min-width: ${this.dataset.sliderInitFrom}px)`).matches))
            return;
        this.slider = slider;
        this.btnPrev = this.querySelector('[data-slider-prev]');
        this.btnNext = this.querySelector('[data-slider-next]');
        this.init = this.init.bind(this);
        if (this.clientWidth === 0) {
            observer.observe(this);
            return;
        }
        this.init();
    }
    init() {
        if (this.slider.scrollWidth <= this.slider.clientWidth)
            return;
        this.initButtons();
        if (window.innerWidth > 1200) {
            this.slider.addEventListener('mousedown', mouseAndWheelHorizontalScrollEvents.mousedown);
        }
    }
    getListOfItems() {
        let items = this.slider.children;
        if (items.length === 1 && items[0].scrollWidth > this.slider.clientWidth) {
            items = items[0].children;
        }
        return items;
    }
    scrollByDistance(distance) {
        let nextPos = this.slider.scrollLeft + distance;
        if (nextPos > 0 && nextPos < this.slider.scrollWidth) {
            for (const item of this.getListOfItems()) {
                const { offsetLeft, offsetWidth } = item;
                if ((offsetLeft <= nextPos && offsetLeft + offsetWidth > nextPos) ||
                    (offsetLeft >= nextPos)) {
                    nextPos = offsetLeft;
                    break;
                }
            }
        }
        this.slider.scrollTo({
            top: 0,
            left: nextPos,
            behavior: 'smooth'
        });
    }
    getScrollDistance() {
        const items = this.getListOfItems();
        let distance = this.slider.clientWidth;
        if (items.length > 1) {
            const computedStyles = getComputedStyle(items[1]);
            const sliderComputedStyle = getComputedStyle(this.slider);
            const sliderColumnGap = sliderComputedStyle.display === 'grid' ? parseFloat(sliderComputedStyle.columnGap) : 0;
            const sliderPaddings = parseFloat(sliderComputedStyle.paddingLeft) + parseFloat(sliderComputedStyle.paddingRight);
            const margins = parseInt(computedStyles.marginRight) + parseInt(computedStyles.marginLeft);
            distance += sliderColumnGap;
            distance -= sliderPaddings;
            distance += margins;
        }
        return distance;
    }
    updateButtons() {
        if (this.slider.scrollWidth <= this.slider.clientWidth) {
            if (this.btnNext !== null) {
                this.btnNext.setAttribute('aria-hidden', 'true');
            }
            if (this.btnPrev !== null) {
                this.btnPrev.setAttribute('aria-hidden', 'true');
            }
        }
    }
    initButtons() {
        this.btnPrev?.addEventListener('click', () => {
            this.scrollByDistance(-this.getScrollDistance());
        });
        if (this.btnNext !== null) {
            this.btnNext.addEventListener('click', () => {
                this.scrollByDistance(this.getScrollDistance());
            });
            this.btnNext.setAttribute('aria-hidden', 'false');
        }
        this.slider.addEventListener('scroll', () => {
            this.btnPrev?.setAttribute('aria-hidden', this.slider.scrollLeft > 2 ? 'false' : 'true');
            this.btnNext?.setAttribute('aria-hidden', this.slider.scrollWidth - this.slider.clientWidth - this.slider.scrollLeft < 2 ? 'true' : 'false');
        });
    }
    update() {
        const slider = this.querySelector('[data-slider]');
        if (slider === null || (this.dataset.sliderInitFrom !== undefined && window.innerWidth < +this.dataset.sliderInitFrom))
            return;
        this.slider = slider;
        this.updateButtons();
    }
}
customElements.define('slider-component', ComponentSlider);
